import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { IntroducerRepAssessment } from '../introducer-rep-assessment-models/introducer-rep-assessment.models';

@Injectable({
  providedIn: 'root'
})
export class IntroducerRepAssessmentService {


  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveintroducerRmassessment(introducerRepAssessment: IntroducerRepAssessment) {

    const API_URL: string = environment.baseUrl + environment.apis.saveintroducerRmassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: introducerRepAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewintroducerRmassessment(viewid: number, status: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewintroducerRmassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        id: viewid,
        status: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['Manager Review', 'Rectification'] : [status],
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getrectificationDocumentsCategorydropdown(role:string) {

    const API_URL: string = environment.baseUrl + environment.apis.documentsCategorydropdown;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        assigned_role: role
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getRectificationdocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['Director', 'Manager', 'Advisor'] : [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
